import React, { Component } from 'react';
import $ from "jquery";
import './css/Account.css';
import { IconButton } from '../components/IconButton';
import { AccountInfoModal } from '../components/AccountInfoModal';
import { GroupInfoModal } from '../components/GroupInfoModal';
import { FunctionModal } from '../components/FunctionModal';
import { cmsAccount, jsonHeaders, msHeaders } from '../components/NavMenu';
import { flushSync } from 'react-dom';

export const Role = {
    Developer: 99,
    Agile: 98,
    Admin: 5,
    Role1: 4,
    Role2: 3,
    Role3: 2,
    Guest: 0
}

export class Account extends Component {
    constructor(props) {
        super(props);
        this.state = {
            account: {},
            email: "",
            users: [],
            companies: [],
            tab: "Users",
            modalShown: false,
            user: null,
            groups: [],
            groupModal: false,
            group: null,
            permissionModal: false,
            selectedCompany: null
        };
    }

    componentDidMount() {
        const intervalId = setInterval(() => {
            if (cmsAccount) {
                this.fetchCompanies();
                this.setState({ account: cmsAccount })
                clearInterval(intervalId);
            }
        }, 100);
    }

    fetchCompanies() {
        var requestOptions = {
            method: 'GET',
            headers: msHeaders,
            redirect: 'follow'
        };
        fetch(`/api/company`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                const companies = [];
                result.forEach(c => {
                    companies.push(c);
                });
                flushSync(() => {
                    this.setState({ companies: companies })
                })
                this.selectCompany("ADS");
            })
    }

    fetchUsers(company) {
        var requestOptions = {
            method: 'GET',
            headers: msHeaders,
            redirect: 'follow'
        };
        fetch(`/api/company/${company.name}/accounts`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.setState({
                    users: result,
                })
            })
        this.fetchGroups(company.name);
    }

    selectCompany(companyName) {
        const { companies } = this.state;
        const company = companies.find(c => c.name == companyName);
        this.setState({ selectedCompany: company });
        this.fetchUsers(company);
    }

    addUser() {
        const email = prompt("Please enter user's email");
        if (email == null)
            return;

        const displayName = prompt("Please enter display name");
        if (displayName == null)
            return;

        const { selectedCompany } = this.state;

        var requestOptions = {
            method: 'POST',
            headers: {
                "Content-type": "application/json",
                "X-Api-Key": selectedCompany.uuid
            },
            body: JSON.stringify({
                username: email,
                displayName
            }),
            redirect: 'follow'
        };
        fetch(`/api/accounts/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.fetchUsers(selectedCompany);
            })
    }

    updateUser(username, property, newValue) {
        console.log(username, property)
        const { selectedCompany } = this.state;

        const raw = {};
        raw[property] = newValue;

        var requestOptions = {
            method: 'PUT',
            headers: {
                "Content-type": "application/json",
                "X-Api-Key": selectedCompany.uuid
            },
            body: JSON.stringify(raw),
            redirect: 'follow'
        };

        fetch(`/api/accounts/${username}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
            })
            .catch(error => console.log('error', error));
    }

    deleteUser(username) {
        console.log(username)
        const { account, selectedCompany } = this.state;
        var requestOptions = {
            method: 'DELETE',
            headers: {
                "Content-type": "application/json",
                "X-Api-Key": selectedCompany.uuid
            },
            redirect: 'follow'
        };
        fetch(`/api/accounts/${username}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.fetchUsers(selectedCompany);
            })
            .catch(error => console.log('error', error));
    }

    showMore(user) {
        this.setState({
            modalShown: true,
            user: user
        })
    }

    setUserRole(uuid, newRole) {
        var requestOptions = {
            method: 'PATCH',
            headers: jsonHeaders,
            body: JSON.stringify({ "role": newRole }),
            redirect: 'follow'
        };

        fetch(`/api/accounts/${uuid}`, requestOptions)
            .then(response => response.text())
            .then(result => {
                console.log(result)
            })
            .catch(error => console.log('error', error));
    }

    fetchGroups(companyName) {
        var requestOptions = {
            method: 'GET',
            headers: msHeaders,
            redirect: 'follow'
        };
        fetch(`/api/groups/`, requestOptions)
            .then(response => response.ok ? response.json() : [])
            .then(result => {
                this.setState({ groups: result })
            })
    }

    addGroup() {
        const { account } = this.state;
        var requestOptions = {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({
                name: "New Group",
                companyUUID: account.companyUUID
            }),
            redirect: 'follow'
        };

        fetch(`/api/groups/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.fetchGroups(account.company);
            })
    }

    updateGroup(uuid, property, newValue) {
        console.log(uuid, property)

        const raw = {};
        raw[property] = newValue;
        console.log(raw)

        var requestOptions = {
            method: 'PATCH',
            headers: jsonHeaders,
            body: JSON.stringify(raw),
            redirect: 'follow'
        };

        fetch(`/api/groups/${uuid}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
            })
            .catch(error => console.log('error', error));
    }

    showGroupMore(group) {
        this.setState({
            groupModal: true,
            group: group
        })
    }


    showPermission(group) {
        this.setState({
            permissionModal: true,
            group: group
        })
    }

    deleteGroup(uuid) {
        const { account } = this.state;
        var requestOptions = {
            method: 'DELETE',
            headers: msHeaders,
            redirect: 'follow'
        };
        fetch(`/api/groups/${uuid}`, requestOptions)
            .then(response => response.text())
            .then(result => {
                console.log(result)
                this.fetchGroups(account.companyUUID);
            })
            .catch(error => console.log('error', error));
    }

    render() {
        const { account, users, tab, modalShown, user, companies, groups, groupModal, group, permissionModal, selectedCompany } = this.state;
        return (
            <>
                <div className='account-page'>
                    <h2>Account: {account.username}</h2>
                    {/* <text>Group: {account.role}</text> */}
                    Company UUID: {account.companyUUID}
                    {account.company == "ADS" ?
                        <>
                            <div className='tab-container'>
                                <button onClick={() => { this.setState({ tab: "Users" }) }}>
                                    Members
                                </button>
                                <button onClick={() => { this.setState({ tab: "Groups" }) }}>
                                    Function Groups
                                </button>
                            </div>
                            <div style={{ display: "flex", marginTop: "20px", alignItems: "center", gap: "10px" }}>
                                Company:
                                <select className="form-select" aria-label="Default select" id="company-menu" onChange={(e) => { this.selectCompany(e.target.value) }} style={{ width: "300px" }}>
                                    {companies.map((company) => {
                                        return (
                                            <option key={company.uuid} id={company.uuid}>{company.name}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div style={tab == "Users" ? {} : { display: "none" }}>
                                <div className='user-table'>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>User Name</th>
                                                <th>Display Name</th>
                                                <th>Active</th>
                                                <th>Functions</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users.map((user) => {
                                                return (
                                                    <tr key={user.id}>
                                                        <td>
                                                            <input
                                                                type="text" className="form-control"
                                                                defaultValue={user.username}
                                                                onBlur={(e) => { this.updateUser(user.username, "username", e.target.value) }}
                                                                placeholder='email@example.com'
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text" className="form-control"
                                                                defaultValue={user.displayName}
                                                                onBlur={(e) => { this.updateUser(user.username, "displayName", e.target.value) }}
                                                            />
                                                        </td>
                                                        <td>{user.active.toString()}</td>
                                                        <td>
                                                            <IconButton
                                                                src={"icons/more.svg"}
                                                                srcWhite={"icons/more-white.svg"}
                                                                onClick={() => { this.showMore(user) }}
                                                            />
                                                        </td>
                                                        <td style={{ display: 'flex' }}>
                                                            <IconButton
                                                                src={"icons/delete.svg"}
                                                                srcWhite={"icons/delete-white.svg"}
                                                                onClick={() => { this.deleteUser(user.username) }}
                                                            />
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{ textAlign: "right" }}>
                                    <button onClick={() => { this.addUser() }}>add user</button>
                                </div>
                            </div>
                            <div style={tab == "Groups" ? {} : { display: "none" }}>
                                <div className='group-table'>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Function Group</th>
                                                {/* <th>Member</th> */}
                                                <th>Permission</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {groups.map((group) => {
                                                return (
                                                    <tr className='header' key={group.uuid}>
                                                        <td onClick={() => { console.log(group) }}>
                                                            <div className="input-group flex-nowrap" style={{ marginLeft: "5px" }}>
                                                                <input type="text" className="form-control" defaultValue={group.name}
                                                                    onBlur={(e) => { this.updateGroup(group.uuid, "name", e.target.value) }} />
                                                            </div>
                                                        </td>
                                                        {/* <td>
                                                    <IconButton
                                                        src={"icons/more.svg"}
                                                        srcWhite={"icons/more-white.svg"}
                                                        onClick={() => { this.showGroupMore(group) }}
                                                    />
                                                </td> */}
                                                        <td>
                                                            <IconButton
                                                                src={"icons/more.svg"}
                                                                srcWhite={"icons/more-white.svg"}
                                                                onClick={() => { this.showPermission(group) }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <IconButton
                                                                src={"icons/delete.svg"}
                                                                srcWhite={"icons/delete-white.svg"}
                                                                onClick={() => { this.deleteGroup(group.uuid) }}
                                                            />
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                {/* <div style={{ textAlign: "right" }}>
                            <button onClick={() => { this.addGroup() }}>add group</button>
                        </div> */}
                            </div>
                        </>
                        : <></>
                    }

                </div>
                <AccountInfoModal
                    user={user}
                    shown={modalShown}
                    closeModal={() => { this.setState({ modalShown: false }) }}
                    updateUser={(...args) => { this.updateUser(...args) }}
                    groups={groups}
                />
                <GroupInfoModal
                    shown={groupModal}
                    closeModal={() => { this.setState({ groupModal: false }) }}
                    group={group}
                />
                <FunctionModal
                    shown={permissionModal}
                    closeModal={() => { this.setState({ permissionModal: false }) }}
                    group={group}
                />
            </>
        );
    }
}